import Link from 'next/link'
import dayjs from 'dayjs'
import { Media } from '@/components'
import { getTranslatedField } from '@/libs/utils'
import type { ArtworkType } from '@/@types/microcms-type'

type Props = {
    projects: ArtworkType[]
    locale?: string
}

export const InvisibleDOM = ({ projects, locale }: Props) => {
    if (!projects) return null
    return (
        <ul className="!pointer-events-none invisible fixed z-[-999] w-0 h-0">
            {projects.map(
                ({ id, project_title, client, thumbnail_image, date }) => (
                    <li key={id}>
                        <Link href={`/project/${id}`}>
                            <Media
                                media={thumbnail_image}
                                altText={getTranslatedField({
                                    field: project_title,
                                    locale
                                })}
                                sizes="1px"
                                quality={1}
                            />
                            <h3>
                                {client &&
                                    getTranslatedField({
                                        field: client,
                                        locale
                                    })}
                            </h3>
                            <h2>
                                {getTranslatedField({
                                    field: project_title,
                                    locale
                                })}
                            </h2>
                            {date && (
                                <time dateTime={date}>
                                    {dayjs(date).format('YYYY')}
                                </time>
                            )}
                        </Link>
                    </li>
                )
            )}
        </ul>
    )
}
